import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/terms-of-services/components/tosPage.tsx");
